import type { TemplateT } from "@/types/database/quickstarts";
import { Expand } from "lucide-react";
import type React from "react";
import { ui } from "../../../components/ui";
import EventsInfo from "./EventsInfo";
import TrackersInfo from "./TrackersInfo";

const TemplateInfoDialog = (
  { template }: { template: TemplateT },
) => {
  return (
    <ui.Dialog>
      <ui.DialogTrigger asChild>
        <ui.Button
          size="sm"
          variant="outline"
          className="flex-no-wrap gap-2 px-2 py-0 h-8"
        >
          Show More <Expand className="w-4 h-4" />
        </ui.Button>
      </ui.DialogTrigger>
      <ui.DialogContent>
        <ui.DialogHeader>
          <ui.DialogTitle>{template.template_name}</ui.DialogTitle>

          <p>{template.template_description}</p>
        </ui.DialogHeader>

        <TrackersInfo template={template} />
        <EventsInfo settings={template.settings} />
      </ui.DialogContent>
    </ui.Dialog>
  );
};

export default TemplateInfoDialog;
